<template>
  <div class="mb-4">
    <h6 class="text-uppercase font-weight-bold text-secondary mb-3">
      <i class="fas fa-users mr-1"></i> People Involved
    </h6>

    <!-- Involved Persons -->
    <div v-if="involvedByType.length > 0" class="mb-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <small class="text-muted font-weight-bold text-uppercase">Persons Involved</small>
        <div>
          <b-link class="small mr-2" @click="selectAll('involved')">Select All</b-link>
          <b-link class="small" @click="deselectAll('involved')">Deselect All</b-link>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-12 mb-2" v-for="person in involvedByType" :key="person.id">
          <div class="card border h-100 cursor-pointer"
               :class="isSelected(person.id) ? 'border-primary shadow-sm' : 'border-light'"
               @click="togglePerson(person.id)">
            <div class="card-body py-2 px-3">
              <div class="d-flex align-items-start justify-content-between">
                <div>
                  <strong class="d-block">{{ person.firstName }} {{ person.lastName }}</strong>
                  <small class="text-muted d-block" v-if="person.address">
                    {{ person.address.streetAddress1 }}, {{ person.address.city }} {{ person.address.state }}
                  </small>
                  <small class="d-block mt-1" v-if="person.phoneNumber">
                    <i class="fas fa-phone-square text-secondary mr-1"></i>{{ person.phoneNumber }}
                  </small>
                  <small class="d-block" v-if="person.affiliation">
                    <i class="fas fa-map-marker text-secondary mr-1"></i>{{ person.affiliation }}
                  </small>
                  <small class="d-block" v-if="person.natureOfInvolvement">
                    <i class="fas fa-info-circle text-secondary mr-1"></i>{{ person.natureOfInvolvement }}
                  </small>
                </div>
                <b-form-checkbox
                  :checked="isSelected(person.id)"
                  size="lg"
                  class="ml-2 flex-shrink-0"
                  @change="togglePerson(person.id)"
                  @click.native.stop
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Witnesses -->
    <div v-if="witnessesByType.length > 0">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <small class="text-muted font-weight-bold text-uppercase">Witnesses</small>
        <div>
          <b-link class="small mr-2" @click="selectAll('witness')">Select All</b-link>
          <b-link class="small" @click="deselectAll('witness')">Deselect All</b-link>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-12 mb-2" v-for="person in witnessesByType" :key="person.id">
          <div class="card border h-100 cursor-pointer"
               :class="isSelected(person.id) ? 'border-primary shadow-sm' : 'border-light'"
               @click="togglePerson(person.id)">
            <div class="card-body py-2 px-3">
              <div class="d-flex align-items-start justify-content-between">
                <div>
                  <strong class="d-block">{{ person.firstName }} {{ person.lastName }}</strong>
                  <small class="text-muted d-block" v-if="person.address">
                    {{ person.address.streetAddress1 }}, {{ person.address.city }} {{ person.address.state }}
                  </small>
                  <small class="d-block mt-1" v-if="person.phoneNumber">
                    <i class="fas fa-phone-square text-secondary mr-1"></i>{{ person.phoneNumber }}
                  </small>
                  <small class="d-block" v-if="person.affiliation">
                    <i class="fas fa-map-marker text-secondary mr-1"></i>{{ person.affiliation }}
                  </small>
                </div>
                <b-form-checkbox
                  :checked="isSelected(person.id)"
                  size="lg"
                  class="ml-2 flex-shrink-0"
                  @change="togglePerson(person.id)"
                  @click.native.stop
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="involvedPeople.length === 0" class="text-muted text-center py-3">
      <i class="fas fa-user-slash fa-2x mb-2 d-block"></i>
      No persons involved recorded for this incident.
    </div>
  </div>
</template>

<script>
export default {
  name: 'IncidentReportPeopleSelector',
  props: {
    involvedPeople: {
      type: Array,
      default: () => []
    },
    selectedPeopleIds: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    involvedByType () {
      return this.involvedPeople.filter(p => p.type === 'Involved')
    },
    witnessesByType () {
      return this.involvedPeople.filter(p => p.type === 'Witness')
    }
  },
  methods: {
    isSelected (id) {
      return this.selectedPeopleIds.includes(id)
    },
    togglePerson (id) {
      const current = [...this.selectedPeopleIds]
      const idx = current.indexOf(id)
      if (idx >= 0) {
        current.splice(idx, 1)
      } else {
        current.push(id)
      }
      this.$emit('update:selectedPeopleIds', current)
    },
    selectAll (type) {
      const people = type === 'involved' ? this.involvedByType : this.witnessesByType
      const toAdd = people.map(p => p.id).filter(id => !this.selectedPeopleIds.includes(id))
      this.$emit('update:selectedPeopleIds', [...this.selectedPeopleIds, ...toAdd])
    },
    deselectAll (type) {
      const people = type === 'involved' ? this.involvedByType : this.witnessesByType
      const removeIds = new Set(people.map(p => p.id))
      this.$emit('update:selectedPeopleIds', this.selectedPeopleIds.filter(id => !removeIds.has(id)))
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
